import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Instructor from '../components/Instructor';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';

export default function Home() {
  return (
    <>
      <Hero />
      <Stats />
      <Instructor />
      <HowItWorks />
      <Pricing />
    </>
  );
}